import { isRecurring } from 'products-ui-components/utils/recurrence';
import { calculateFixedDiscountedLineItemPrice, calculateFixedSubtotal } from 'products-ui-components/utils/calculations/fixedPricing';
import { calculateRecurringDiscountedLineItemPrice, calculateRecurringSubtotal } from 'products-ui-components/utils/calculations/recurringPricing';
import { ANNUALLY } from 'customer-data-objects/product/BillingFrequency';
// *********************************************************
// * Price calculations for fixed AND recurring line items *
// *********************************************************
export const calculateDiscountedLineItemPrice = (lineItem, billingFrequency) => {
  return isRecurring(lineItem) ? calculateRecurringDiscountedLineItemPrice(lineItem, billingFrequency) : calculateFixedDiscountedLineItemPrice(lineItem);
};

/**
 * Returns the total price of all line items, both single and recurring billed,
 * per the specified time period.
 * Total calculated price includes all discounts, both fixed and percentage, but
 * not costs (to the HubSpot customer).
 *
 * @param {Array | ImmutableMap} lineItems - The lineItems for which to calculate total discounted
                             price.
 * @param {string} billingFrequency - String representation of the period of time per
 *                             which to calculate total discounted price.
 * @return {number} The total, discounted price of all line items, per the period
 *                  of time specified.
 */
export const calculateSubtotal = (lineItems, billingFrequency = ANNUALLY) => {
  return calculateFixedSubtotal(lineItems) + calculateRecurringSubtotal(lineItems, billingFrequency);
};